// Indian construction imagery + brand constants
export const IMG = {
  heroWorkers: "https://images.unsplash.com/photo-1632201147654-f6f54427e538?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  workersGroup: "https://images.unsplash.com/photo-1577199001468-44c049e7603f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cranesSkyline: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  highrise: "https://images.unsplash.com/photo-1632398535774-b95738ddff68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  siteSunset: "https://images.unsplash.com/photo-1630309904321-4f320230bced?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  villa: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  villaDusk: "https://images.unsplash.com/photo-1722421492323-eaf9c401befe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  homeLawn: "https://images.unsplash.com/photo-1766603636700-e9d80473f40f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  homeWhite: "https://images.unsplash.com/photo-1762811054947-605b20298615?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  blueprint: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  materials: "https://images.unsplash.com/photo-1694521787673-28cbd8830ea5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV = [
  { label: "Platform", to: "/platform" },
  { label: "Solutions", to: "/solutions" },
  { label: "Industries", to: "/industries" },
  { label: "Marketplace", to: "/market" },
  { label: "Intelligence", to: "/intelligence" },
  { label: "Blog", to: "/blog" },
  { label: "Resources", to: "/resources" },
];

export const inr = (n) => {
  if (n == null || isNaN(n)) return "₹0";
  const v = Number(n);
  if (v >= 10000000) return `₹${(v / 10000000).toFixed(2)} Cr`;
  if (v >= 100000) return `₹${(v / 100000).toFixed(2)} L`;
  if (v >= 1000) return `₹${(v / 1000).toFixed(1)}K`;
  return `₹${v.toLocaleString("en-IN")}`;
};

export const inrFull = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
